<template>
  <div
    class="input input--radio"
    :class="{
      'input--error': error,
      'input--disabled': disabled,
      'input--checked': checked,
    }"
    @mouseover="$emit('mouseover')"
    @mouseleave="$emit('mouseleave')"
  >
    <input
      :id="id"
      :value="value"
      type="radio"
      :name="name"
      :checked="checked"
      :required="required"
      :disabled="disabled"
      @input="input"
    />
    <label :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: 'InputRadio',
  props: {
    id: { type: String, required: true },
    name: { type: String, required: true },
    value: { type: String, required: true },
    required: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    input(ev) {
      this.$emit('input', ev.target.checked)
    },
  },
}
</script>

<style lang="scss">
.input--radio {
  input {
    @include visually-hidden;
  }

  label {
    --checked-size: #{rem(8px)};

    display: block;
    padding-left: rem($spacing * 1.5);
    line-height: 1.6;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: rem(16px);
      height: rem(16px);
      border: rem(1px) solid var(--secondary-color);
      border-radius: 50%;
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: var(--checked-size);
      transform: translate(-50%, -50%) scale(0);
      opacity: 0;
      background: var(--secondary-color);
      width: var(--checked-size);
      height: var(--checked-size);
      border-radius: 50%;
      transition: all 0.3s;
    }
  }

  input:checked + label {
    &::after {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
  }

  &.input--error {
    label {
      &::before {
        border-color: var(--error-color);
      }
    }
  }

  &.input--disabled {
    label {
      cursor: not-allowed;

      &::before {
        border-color: var(--disabled-color);
      }
    }
  }
}
</style>
